import React from 'react';
import { useLocation } from 'react-router-dom';
import { GnbHover } from '@repo/common';
import {
  getDropdownItems,
  getGnbDropdownConfig,
  getNavItems,
} from './jobNavigationConfig';
import { useAuth } from '@repo/common';

const cx = (...classes) => classes.filter(Boolean).join(' ');

const NavRoot = ({ className = '', ...props }) => (
  <nav
    {...props}
    className={cx(
      'hidden tabletV:inline-flex tabletV:-ml-2 tabletV:gap-4 desktopL:gap-[18px] desktopXXL:gap-[20px]',
      className,
    )}
  />
);

const NavScrolled = ({ className = '', ...props }) => (
  <nav
    {...props}
    className={cx(
      'flex justify-center gap-4 desktopL:gap-[26px] desktopXXL:gap-9',
      className,
    )}
  />
);

function PrimaryNavigation({
  activePath,
  onSelect = () => {},
  variant = 'default',
  onLoginRequired,
}) {
  const NavComponent = variant === 'scrolled' ? NavScrolled : NavRoot;
  const location = useLocation();
  const { user } = useAuth();
  const navItems = getNavItems(user?.role);
  const currentPath = location?.pathname ?? '/';
  // 마이페이지는 어느 GNB 메뉴에도 속하지 않으므로 밑줄을 표시하지 않는다
  // (드롭다운의 My Apply·Manage Resume 링크가 /mypage 라서 매칭되던 문제 방지)
  const isMyPage = currentPath.startsWith('/mypage');
  const matchesPath = (href) => {
    const path = (href || '').split('?')[0];
    if (!path) return false;
    return path === '/' ? currentPath === '/' : currentPath.startsWith(path);
  };
  const matchedNavItem = navItems.find(({ label, href }) => {
    if (matchesPath(href)) {
      return true;
    }
    const dropdowns = getDropdownItems(label, user?.role);
    return dropdowns.some(({ href: itemHref }) => matchesPath(itemHref));
  });
  const resolvedActivePath = isMyPage
    ? null
    : matchedNavItem?.href || activePath || null;

  return (
    <NavComponent aria-label='Primary navigation'>
      {navItems.map(({ label, href, external, tooltip }) => (
        <GnbHover
          key={label}
          label={label}
          href={href}
          external={external}
          tooltip={tooltip}
          variant={variant}
          active={resolvedActivePath === href}
          onSelect={() => onSelect(href)}
          dropdown={getGnbDropdownConfig(label, user?.role)}
          onLoginRequired={onLoginRequired}
        />
      ))}
    </NavComponent>
  );
}

export default PrimaryNavigation;
